module.exports = __webpack_public_path__ + "media/images/undraw/matching/chat_bot-bf497915acdf86437a2895049cd1fa41.png";